export default __webpack_public_path__ + "static/media/twitter.d4c78420.svg";